import { useDispatch, useSelector } from "react-redux";
import ModalCloseButton from "./ModalCloseButton";
import { setActiveProject } from "../../store";

function Modal() {
  const dispatch = useDispatch();
  const { activeProject, projectData } = useSelector((state) => state.app);

  const activeProjectData = projectData[activeProject];

  const onClose = () => {
    dispatch(setActiveProject(null));
  };

  const keywordsList = activeProjectData.keywords.map((keyword, index) => [
    index > 0 && ", ",
    <a
      href={`https://www.google.com/search?q=${keyword.toLowerCase()}`}
      target="_blank"
      className="project-keyword"
      rel="noreferrer"
      key={index}
    >
      {keyword}
    </a>,
  ]);

  const skillsList = activeProjectData.skills.map((skill) => (
    <div
      key={skill}
      className="h-4 px-1 mr-2 font-medium skill-label text-[0.6rem] text-black min-w-[25px] w-max flex flex-col justify-center items-center"
    >
      {skill}
    </div>
  ));

  return (
    <div className="w-[85vw] h-[80vh] top-[65px] left-0 right-0 mx-auto absolute expanded-modal overflow-hidden flex flex-row">
      <ModalCloseButton
        className="absolute right-3 bottom-3"
        onClick={onClose}
      />
      <div className="bg-black h-full w-[27%] select-none flex flex-col items-center justify-center relative">
        <img
          src={activeProjectData.longImg}
          alt={activeProjectData.title}
          className="w-full h-full object-cover"
        />
        <div
          className="absolute w-full top-0 left-0 h-full z-20"
          style={{
            WebkitBoxShadow: "inset 0px 0px 11px -3px rgba(0,0,0,0.77)",
            boxShadow: "inset 0px 0px 15px -3px rgba(0,0,0,0.77)",
            borderRadius: "24px 0 0 0",
          }}
        />
      </div>
      <div className="h-full w-[73%] flex flex-col text-white pt-10 pl-3 pr-7">
        <div className="text-5xl font-medium">{activeProjectData.title}</div>
        <div className="mt-4">{activeProjectData.date}</div>
        <div className="mt-0.5">Created at: {activeProjectData.createdAt}</div>
        <div className="mt-0.5">Keywords: {keywordsList}</div>
        <div className="flex flex-row mt-3 max-w-[60%] flex-wrap">
          {skillsList}
        </div>
        <div className="mt-10 max-h-[45%] overflow-y-auto whitespace-pre-wrap">
          <p>{activeProjectData.longDesc}</p>
        </div>
        <div className="mt-10">
          <p>
            This project is available at:{" "}
            <a
              href={activeProjectData.externalLink}
              target="_blank"
              className="underline cyan-text hover:no-underline"
              rel="noreferrer"
            >
              &lt;project-link&gt;
            </a>
            .
          </p>
        </div>
        <div className="absolute right-0 top-0 yellow-bg w-[18px] h-[144px]" />
        <div className="absolute right-0 top-0 yellow-bg h-[18px] w-[144px]" />
      </div>
    </div>
  );
}

export default Modal;
